import React, { useState } from "react";
import { Button } from "primereact/button";
import "primereact/resources/themes/saga-blue/theme.css"; // or any other theme
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { Loader } from "rsuite";
import GlobalPopup from "../GlobalComponents/GlobalPopup";

const DeleteOfTheMonthDialog = ({ visible, onHide, onConfirm, isLoading }) => {
  const DeleteOfTheMonthDialogConfimration = (
    <>
      <div>
        <Button
          style={{ borderRadius: "5px", padding: "15px" }}
          label="Yes"
          icon="pi pi-check"
          onClick={onConfirm}
          autoFocus
        />
        <Button
          style={{
            borderRadius: "5px",
            padding: "15px",
            backgroundColor: "lightslategray",
            color: "white",
          }}
          label="Cancel"
          icon="pi pi-times"
          onClick={onHide}
          className="p-button-text"
        />
      </div>
    </>
  );
  const ConfirmationContent = (
    <>
      <div className="confirmation-content">
        <h6> Do You Want to Delete of the Month ...?</h6>
        {isLoading && (
          <div className="loader-container">
            <Loader content="loading..." />
          </div>
        )}
      </div>
    </>
  );
  return (
    <GlobalPopup
      title={"Confirmation"}
      visible={visible}
      onHide={onHide}
      footerButtons={DeleteOfTheMonthDialogConfimration}
      content={ConfirmationContent}
    />
  );
};

export default DeleteOfTheMonthDialog;
